import { handleActions } from 'redux-actions'

import { getLoginStatus } from '../../utils/userHelper'
import {
  logoutRequest,
  resetLoggingIn,
  signInRequest,
  signInSucceed
} from './actions'

export const INITIAL_STATE = {
  isLoggedIn: false || getLoginStatus().isLoggedIn,
  isLoggingIn: false
}

type State = typeof INITIAL_STATE

export const authReducer = handleActions<State, boolean>(
  {
    [signInRequest.toString()]: (state) => ({
      ...state,
      isLoggingIn: true
    }),
    [signInSucceed.toString()]: (state) => ({
      ...state,
      isLoggedIn: true,
      isLoggingIn: false
    }),
    [logoutRequest.toString()]: (state) => ({ ...state, isLoggedIn: false }),
    [resetLoggingIn.toString()]: (state) => ({
      ...state,
      isLoggedIn: false,
      isLoggingIn: false
    })
  },
  INITIAL_STATE
)
